import React from 'react';
import './Topbar.css';
import { useLocale } from '../context/LocaleContext';
import HeaderSocialLinks from '../Components/HeaderSocialLinks';
import LanguageSwitcher from '../Components/LanguageSwitcher';
import { CLINIC_PHONE, buildWhatsAppUrl } from '../data/clinicContact';

const Topbar = () => {
  const { t } = useLocale();
  const whatsappUrl = buildWhatsAppUrl(t('home.whatsappMsg'));

  return (
    <aside className="topbar" aria-label={t('topbar.ariaLabel')}>
      <div className="topbar_inner">
        <div className="topbar_spacer" aria-hidden="true" />

        <div className="topbar_right_cluster">
          <a
            className="topbar_phone"
            href={CLINIC_PHONE.href}
            aria-label={t('topbar.callAria')}
          >
            <i className="fa-solid fa-phone" aria-hidden="true" />
            {CLINIC_PHONE.label}
          </a>

          <a
            className="topbar_whatsapp"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('topbar.whatsappAria')}
          >
            <i className="fa-brands fa-whatsapp" aria-hidden="true" />
            <span>WhatsApp</span>
          </a>

          <span className="topbar_divider" aria-hidden="true" />

          <HeaderSocialLinks
            className="topbar_social"
            linkClassName="topbar_social_link"
          />

          <span className="topbar_divider" aria-hidden="true" />

          <LanguageSwitcher className="topbar_lang" />
        </div>

        <div className="topbar_nav_spacer" aria-hidden="true" />
      </div>
    </aside>
  );
};

export default Topbar;
